import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { IUsers } from "../types";

export const addUser = async (props: IUsers) => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/register`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const data: any = {
    name: props.name,
    email: props.email,
    role: props.roles,
  };

  const response = await axios.post(url, data, config);
  return response;
};

export const useAddUser = () => {
  return useMutation(addUser);
};